import React from 'react';
import styles from '../../styles/components/tab/TabLabel.module.css';
import { FaCheckCircle } from 'react-icons/fa';
export interface TabLabelProps {
  type?: 'simple' | 'complex';
  title: string;
  subtitle?: string;
}

export interface TabLabelActiveProps {
  active?: boolean;
  isCompeleted?: string;
}

const SimpleLabel: React.FC<TabLabelProps & TabLabelActiveProps> = ({
  title,
  active,
  isCompeleted,
}) => (
  <div className={styles.container}>
    <div
      className={[styles.simpleTitle, active ? styles.simpleActive : ''].join(
        ' '
      )}
    >
      <div className={styles.title}>
        {title}
        {isCompeleted === 'true' && (
          <FaCheckCircle
            className={styles.checkicon}
            size={21}
            color="#4bae4f"
          />
        )}
      </div>
    </div>
  </div>
);

const ComplexLabel: React.FC<TabLabelProps & TabLabelActiveProps> = ({
  title,
  subtitle,
  active,
}) => (
  <div className={styles.container}>
    <div
      className={[styles.complexTitle, active ? styles.complexActive : ''].join(
        ' '
      )}
    >
      {title}
    </div>
    {subtitle && (
      <div
        className={[
          styles.complexSubtitle,
          active ? styles.complexActive : '',
        ].join(' ')}
      >
        {subtitle}
      </div>
    )}
  </div>
);

export const TabLabel: React.FC<
  TabLabelProps & TabLabelActiveProps
> = props => {
  return props.type === 'complex' ? (
    <ComplexLabel {...props} />
  ) : (
    <SimpleLabel {...props} />
  );
};

export default TabLabel;
